import React, { useEffect, useState } from "react";
import { HardDrive, CheckCircle2, AlertTriangle } from "lucide-react";
import api from "../../lib/api";
import { useLang } from "../../context/LangContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";

export default function MyCloudSettings({ s, set }) {
  const { t } = useLang();
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/dub/mycloud/status").then((r) => setSt(r.data)).catch(() => setSt({ configured: false })); }, [s.mycloud_enabled, s.mycloud_folder]);
  return (
    <div className="rounded-2xl border border-white/10 bg-card p-6 space-y-4" data-testid="mycloud-settings">
      <h3 className="font-heading font-bold flex items-center gap-2"><HardDrive className="h-4 w-4 text-primary" />{t("Pasta de trabalho My Cloud", "My Cloud working folder")}</h3>
      <p className="text-xs text-muted-foreground">{t("Originais, vídeos dobrados e legendas ficam no teu My Cloud (subpasta ReiMultiBlog) em vez do disco do servidor. Os vídeos colocados nesta pasta podem ser importados diretamente.", "Originals, dubbed videos and subtitles are stored in your My Cloud (ReiMultiBlog subfolder) instead of the server disk. Videos placed in this folder can be imported directly.")}</p>
      <label className="flex items-center justify-between text-sm">
        <span>{t("Usar o My Cloud", "Use My Cloud")}</span>
        <Switch data-testid="mycloud-enabled-switch" checked={!!s.mycloud_enabled} onCheckedChange={(v) => set("mycloud_enabled", v)} />
      </label>
      <div>
        <Label className="text-xs">{t("Link da pasta (ex.: https://os5.mycloud.com/cloud/folders/…)", "Folder link (e.g. https://os5.mycloud.com/cloud/folders/…)")}</Label>
        <Input data-testid="mycloud-folder-input" className="mt-1.5" value={s.mycloud_folder || ""} onChange={(e) => set("mycloud_folder", e.target.value)} />
      </div>
      <p className="text-xs flex items-center gap-1.5" data-testid="mycloud-status">
        {st?.connected && st?.folder_ok
          ? <><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" />{t("Ligado ao dispositivo", "Connected to device")} {st.device}{st.enabled ? "" : ` · ${t("desativado", "disabled")}`}</>
          : <><AlertTriangle className="h-3.5 w-3.5 text-amber-400" />{!st ? "…" : !st.configured ? t("Conta My Cloud não configurada", "My Cloud account not configured") : st.error || t("Pasta não encontrada", "Folder not found")}</>}
      </p>
      <p className="text-[11px] text-muted-foreground">{t("Guarde as configurações para aplicar.", "Save settings to apply.")}</p>
    </div>
  );
}
